import { render, staticRenderFns } from "./AddWarehouseComponent.vue?vue&type=template&id=435262ea"
import script from "./AddWarehouseComponent.vue?vue&type=script&lang=js"
export * from "./AddWarehouseComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports